import type { ItemId } from "../inventory/ItemDefinitions";

export enum EquipmentAnimationState { EQUIPPING="EQUIPPING", IDLE="IDLE", DRAWING="DRAWING", READY="READY", USING="USING", FIRING="FIRING", RECOVERING="RECOVERING" }

export class EquipmentAnimator {
  private current = EquipmentAnimationState.EQUIPPING;
  private elapsed = 0;
  private duration = 0.22;
  private item: ItemId = "coins";
  private fireEvent = false;
  private firedPower = 0;

  get state(): EquipmentAnimationState { return this.current; }
  get normalizedTime(): number { return this.duration <= 0 ? 1 : Math.min(1, this.elapsed / this.duration); }
  get isAiming(): boolean { return false; }
  get drawAmount(): number { return 0; }
  get lastShotPower(): number { return this.firedPower; }

  select(item: ItemId): void { this.item = item; this.fireEvent = false; this.firedPower = 0; this.enter(EquipmentAnimationState.EQUIPPING, 0.22); }
  setAiming(_aiming: boolean): void { /* Compatibility no-op: the slingshot is now one-click automatic. */ }

  triggerUse(): boolean {
    if (this.item === "slingshot") {
      if (this.current !== EquipmentAnimationState.IDLE) return false;
      this.firedPower = 1;
      this.fireEvent = true;
      this.enter(EquipmentAnimationState.FIRING, 0.2);
      return true;
    }
    if (this.current !== EquipmentAnimationState.IDLE) return false;
    this.enter(EquipmentAnimationState.USING, this.item === "bottle" ? 0.5 : 0.34);
    return true;
  }

  consumeFireEvent(): boolean { const queued = this.fireEvent; this.fireEvent = false; return queued; }
  cancel(): void { this.fireEvent = false; this.firedPower = 0; this.enter(EquipmentAnimationState.IDLE, 0); }

  update(deltaSeconds: number): void {
    this.elapsed += deltaSeconds;
    if (this.current === EquipmentAnimationState.EQUIPPING && this.elapsed >= this.duration) this.enter(EquipmentAnimationState.IDLE, 0);
    else if ((this.current === EquipmentAnimationState.USING || this.current === EquipmentAnimationState.FIRING) && this.elapsed >= this.duration) this.enter(EquipmentAnimationState.RECOVERING, this.item === "slingshot" ? 0.04 : 0.17);
    else if (this.current === EquipmentAnimationState.RECOVERING && this.elapsed >= this.duration) this.enter(EquipmentAnimationState.IDLE, 0);
  }

  private enter(state: EquipmentAnimationState, duration: number): void { this.current = state; this.elapsed = 0; this.duration = duration; }
}
